import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ImCross } from "react-icons/im";

export const ImageModal = ({ images, openImg, selectedImgIndex, onClose }) => {
  const [swiperRef, setSwiperRef] = useState(null);

  useEffect(() => {
    if (swiperRef && selectedImgIndex !== null) {
      swiperRef.slideTo(selectedImgIndex, 0); // Go to selected image instantly
    }
  }, [swiperRef, selectedImgIndex]);

  if (!openImg) return null; // Don't render when modal is closed

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg px-4 pt-2 w-full max-w-4xl relative flex flex-col items-center">
        <button
          className="absolute top-0 right-0 text-black rounded-full text-md font-semibold transition-transform transform hover:scale-110 w-8 h-8 flex items-center justify-center"
          onClick={onClose}
        >
          <ImCross />
        </button>

        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          onSwiper={setSwiperRef}
          navigation
          className="w-full h-[500px]"
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={img}
                alt={`Slide ${index}`}
                className="w-full h-full p-4 object-cover rounded-lg"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
